export default "__VITE_ASSET__CGoXbJTa__"